module.exports = __webpack_public_path__ + "static/media/arrow-right.7d2d7c53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-right.svg
// module id = 103
// module chunks = 0